import { createFileRoute } from "@tanstack/react-router";
import { SiteFooter, SiteHeader } from "@/components/tools/ToolShell";

export const Route = createFileRoute("/fr/contact")({
  head: () => ({
    meta: [
      { title: "Contact — Picamini.online" },
      {
        name: "description",
        content: "Contactez l'équipe de Picamini.online pour vos questions, suggestions d'outils ou demandes de partenariat.",
      },
    ],
    links: [
      { rel: "canonical", href: "https://picamini.online/fr/contact" },
      { rel: "alternate", hrefLang: "en", href: "https://picamini.online/contact" },
      { rel: "alternate", hrefLang: "es", href: "https://picamini.online/es/contacto" },
      { rel: "alternate", hrefLang: "de", href: "https://picamini.online/de/kontakt" },
      { rel: "alternate", hrefLang: "pt-BR", href: "https://picamini.online/pt-br/contato" },
      { rel: "alternate", hrefLang: "fr", href: "https://picamini.online/fr/contact" },
      { rel: "alternate", hrefLang: "x-default", href: "https://picamini.online/contact" },
    ],
  }),
  component: FrContactPage,
});

function FrContactPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col font-sans">
      <SiteHeader lang="fr" />

      <main className="flex-1 py-12 mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 space-y-6">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-foreground">Contactez-nous</h1>

        <p className="text-base text-muted-foreground leading-relaxed">
          Vous avez une question, une suggestion de nouvel outil pédagogique ou un retour d'expérience à partager ? Notre équipe est toujours à l'écoute des enseignants, utilisateurs et partenaires.
        </p>

        <div className="rounded-2xl border border-border/80 bg-card p-6 space-y-4 shadow-xs">
          <h2 className="text-xl font-bold text-foreground">Assistance et Retours</h2>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Écrivez-nous à : <a href="mailto:support@picamini.online" className="font-bold text-primary hover:underline">support@picamini.online</a>
          </p>
          <p className="text-xs text-muted-foreground">
            Nous répondons généralement sous 24 à 48 heures ouvrées.
          </p>
        </div>
      </main>

      <SiteFooter lang="fr" />
    </div>
  );
}
